import { AWARD_POSTER_BACKGROUND, homeAwardPoster, ORIGINAL_AWARD_POSTER } from '../../content/homeAwardPoster';
import { getHtmlLangFromRouteLanguage, type RouteLanguageCode } from '../../utils/languageRouting';
import './award-poster.css';

export default function AwardPoster({ language }: { language: RouteLanguageCode }) {
  const copy = homeAwardPoster[language];
  const isChinese = language === 'hk' || language === 'cn';

  return (
    <div
      className="award-poster"
      data-award-language={language}
      lang={getHtmlLangFromRouteLanguage(language)}
      role="img"
      aria-label={`${copy.brand}. 2026. ${copy.title}. ${copy.subtitle}. ${copy.tagline}`}
      dir="ltr"
    >
      <img
        src={language === 'hk' ? ORIGINAL_AWARD_POSTER : AWARD_POSTER_BACKGROUND}
        alt=""
        aria-hidden="true"
        className="award-poster__background"
        loading="eager"
        decoding="async"
        width={1448}
        height={1086}
      />
      {language !== 'hk' && (
        <>
          <div className={`award-poster__brand${isChinese ? ' award-poster__brand--chinese' : ''}`}>
            <img
              src="/img/0c35285da7db83dd4744dcd7f9c41cc3.png"
              alt=""
              aria-hidden="true"
              className="award-poster__emblem"
            />
            <div className="award-poster__wordmark" dir="ltr">
              <span className="award-poster__brand-name">{copy.brand}</span>
              {isChinese && <span className="award-poster__brand-english">Gold Label Global</span>}
            </div>
          </div>
          <div className="award-poster__rule award-poster__rule--top" />
          <span className="award-poster__year" dir="ltr">2026</span>
          <div className="award-poster__copy" dir={language === 'ug' ? 'rtl' : 'ltr'}>
            <span className="award-poster__title">{copy.title}</span>
            <span className="award-poster__subtitle">{copy.subtitle}</span>
            <span className="award-poster__rule award-poster__rule--bottom" />
            <span className="award-poster__tagline">{copy.tagline}</span>
          </div>
        </>
      )}
    </div>
  );
}
